import { createContext } from 'react'

interface UseBefehleAlleGelesenContextType {
  befehleAlleGelesen: boolean
  setBefehleAlleGelesen: (gelesen: boolean) => void
}

const BefehleAlleGelesenContext =
  createContext<UseBefehleAlleGelesenContextType>({
    befehleAlleGelesen: false,
    setBefehleAlleGelesen: () => {}
  })

export default BefehleAlleGelesenContext
